import Quill from "quill";

export const DEFAULT_QUILL_TOOLBAR = [
  [{ header: [1, false] }],
  ["bold", "italic", "underline"],
];

function forceLtrInEditor(quill) {
  if (!quill) return;
  const root = quill.root;
  root.setAttribute("dir", "ltr");
  root.style.direction = "ltr";
  root.style.textAlign = "left";
  root.style.unicodeBidi = "normal";

  const rtlNodes = root.querySelectorAll(
    '[dir="rtl"], .ql-direction-rtl, .ql-align-right',
  );
  rtlNodes.forEach((node) => {
    node.removeAttribute?.("dir");
    node.classList?.remove("ql-direction-rtl");
    node.classList?.remove("ql-align-right");
  });
}

export function createQuillEditor({
  container,
  toolbar = DEFAULT_QUILL_TOOLBAR,
  initialHtml = "",
  placeholder = "Compose an epic...",
  theme = "snow",
}) {
  if (!container) return null;
  container.setAttribute("dir", "ltr");

  const quill = new Quill(container, {
    theme,
    placeholder,
    modules: {
      toolbar,
    },
    formats: ["header", "bold", "italic", "underline"],
  });

  quill.root.setAttribute("dir", "ltr");
  quill.root.parentElement?.setAttribute("dir", "ltr");
  quill.root.style.direction = "ltr";
  quill.root.style.textAlign = "left";
  quill.root.style.unicodeBidi = "normal";
  if (initialHtml) {
    quill.clipboard.dangerouslyPasteHTML(initialHtml);
  }
  forceLtrInEditor(quill);
  return quill;
}

export function getQuillHtml(quill) {
  if (!quill) return "";
  return quill.root.innerHTML;
}

export function setQuillHtml(quill, html) {
  if (!quill) return;
  if (!html) {
    quill.setText("");
    return;
  }
  quill.clipboard.dangerouslyPasteHTML(html);
}

export function destroyQuillEditor({ container, quill, textChangeHandler }) {
  if (quill && textChangeHandler) {
    quill.off("text-change", textChangeHandler);
  }
  if (container) {
    container.innerHTML = "";
  }
}
